import API from "./API";
import axios from "axios";

export const Emails = {

    async getAll(){
        const url = API.url('/emails');
        return await axios.get(url);
    },

    async get(id){
        const url = API.url('/emails/' + id);
        return await axios.get(url);
    },

    async toggle(id){
        const url = API.url('/emails/' + id + '/toggle');
        return await axios.get(url);
    },

    async put(data){
        const url = API.url('/emails/' + data.id);
        return await axios.put(url, data);
    },

    async test(id, recipient){
        const url = API.url(`/emails/${id}/test/${recipient}`);
        return await axios.get(url);
    },

}

export default Emails;